import IntegrationApi from 'api/integrationApi'
import {
  IntegrationListRequest,
  IntegrationListResponse,
  IntegrationSaveRequest
} from './types'

const IntegrationApiSlice = IntegrationApi.injectEndpoints({
  endpoints: (build) => ({
    getClientIntegration: build.query<
      IntegrationListResponse,
      IntegrationListRequest
    >({
      query: ({ filters, page, id }) => {
        const params: { [key: string]: any } = {
          size: page?.size,
          page: page?.number ? page.number - 1 : 0,
          id
        }

        // Make sure filters are part of the request
        if (filters && filters.length > 0) {
          filters.forEach(({ fieldName, fieldValue }) => {
            if (
              fieldValue === null ||
              fieldValue === undefined ||
              fieldValue === '' ||
              fieldValue === 'all'
            ) {
              delete params[fieldName]
            } else {
              params[fieldName] = fieldValue
            }
          })
        }

        return {
          url: `/document-ai/v1/integrations`,
          method: 'GET',
          params
        }
      },
      providesTags: ['integration']
    }),
    createIntegration: build.mutation<
      IntegrationSaveRequest,
      IntegrationListResponse
    >({
      query: ({ integrationDTO }) => {
        return {
          url: '/document-ai/v1/integrations',
          data: integrationDTO,
          method: 'POST'
        }
      },
      invalidatesTags: ['integration']
    })
  })
})

export const { useGetClientIntegrationQuery, useCreateIntegrationMutation } =
  IntegrationApiSlice
